export const currentBrand = process.env.REACT_APP_WEBSITE_BRAND || 'vwfs';
export const integrationApiBaseUrl = process.env.REACT_APP_INTEGRATION_API_BASE_URL;
export const integrationApiBaseUrlLocal = process.env.REACT_APP_API_BASE_URL_LOCAL;
export const apiGatewayConsumerName = 'vwfs-du-cpmx';
export const idpHint = process.env.REACT_APP_IDP_HINT;
export const paymentReferenceUrl = process.env.REACT_APP_PAYMENT_REFERENCE_URL;
